module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售下单号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单时间："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ProjectTypeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务员："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所选套餐："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTitle))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.PackageId == 599),
      expression: "OrderData.PackageId==599"
    }],
    attrs: {
      "label": "套餐明细"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.OrderData.PackageList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "套餐名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.PackageName) + "\n                            "), (scope.row.ChargeTypeName !== '') ? _c('span', [_vm._v("(" + _vm._s(scope.row.ChargeTypeName) + ")")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ClassNum",
      "label": "开班数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单对象："
    }
  }, [(_vm.OrderData.ObjectName !== '') ? _c('span', [_vm._v(_vm._s(_vm.OrderData.ObjectName))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "销售总价："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.PreOrderPrice) + " 元")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "需支付："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderActualPrice) + " 元")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理信息:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.OrderData.AreaNames,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "代理项目",
      "prop": "ProjectTypeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代理政策",
      "prop": "PolicyTypeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代理级别",
      "prop": "RebateLevelName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "区域",
      "prop": "AreaList"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.AreaList), function(item, index) {
          return _c('span', [_c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index > 1),
              expression: "index>1"
            }]
          }, [_vm._v(",")]), _vm._v(" " + _vm._s(item.ProvName) + _vm._s(item.CityName) + _vm._s(item.AreaName) + "\n                            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同预付款",
      "prop": "ContractMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合计金额:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderActualPrice) + " 元")])]), _vm._v(" "), (_vm.OrderData.IsErpOrder == 1) ? _c('div', [_c('h4', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_vm._v("支付信息")]), _vm._v(" "), _vm._l((_vm.OrderData.PayList), function(item, index) {
    return _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": '支付方式-' + (index + 1)
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayWayName))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWay !== 6 && item.PayWay !== 9),
        expression: "item.PayWay!==6&&item.PayWay!==9"
      }],
      attrs: {
        "label": "支付金额："
      }
    }, [_c('span', [_vm._v(_vm._s(item.OrderActualPrice))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.changePic.length > 0),
        expression: "item.changePic.length>0"
      }],
      attrs: {
        "label": "支付凭证"
      }
    }, _vm._l((item.changePic), function(item2) {
      return _c('div', {
        attrs: {
          "id": "ImgPrev"
        }
      }, [_c('div', {
        staticClass: "post-format-content"
      }, [_c('div', {
        staticClass: "post-thumbnail"
      }, [_c('img', {
        staticClass: "attachment-thumbnail wp-post-image",
        attrs: {
          "id": "myProPic",
          "src": item2.Url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content-wrap"
      }, [_c('span', {
        staticClass: "entry-title"
      }, [_c('span', {
        staticClass: "featured-image",
        on: {
          "click": function($event) {
            _vm.LookPicture(item2.Url)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-view"
      })])])])])])
    })), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.Trade_No !== ''),
        expression: "item.Trade_No!==''"
      }],
      attrs: {
        "label": "支付凭证单号："
      }
    }, [_c('span', [_vm._v(_vm._s(item.Trade_No))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWay == 8),
        expression: "item.PayWay==8"
      }],
      attrs: {
        "label": "支付说明："
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayRemark))])])], 1)
  })], 2) : _c('div', _vm._l((_vm.OrderData.PayList), function(item, index) {
    return _c('el-row', [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWayName !== ''),
        expression: "item.PayWayName!==''"
      }],
      attrs: {
        "label": "支付方式："
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayWayName))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.changePic.length > 0),
        expression: "item.changePic.length>0"
      }],
      attrs: {
        "label": "支付凭证："
      }
    }, _vm._l((item.changePic), function(item2) {
      return _c('div', {
        attrs: {
          "id": "ImgPrev"
        }
      }, [_c('div', {
        staticClass: "post-format-content"
      }, [_c('div', {
        staticClass: "post-thumbnail"
      }, [_c('img', {
        staticClass: "attachment-thumbnail wp-post-image",
        attrs: {
          "id": "myProPic",
          "src": item2.Url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content-wrap"
      }, [_c('span', {
        staticClass: "entry-title"
      }, [_c('span', {
        staticClass: "featured-image",
        on: {
          "click": function($event) {
            _vm.LookPicture(item2.Url)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-view"
      })])])])])])
    })), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.Trade_No !== ''),
        expression: "item.Trade_No!==''"
      }],
      attrs: {
        "label": "支付凭证单号："
      }
    }, [_c('span', [_vm._v(_vm._s(item.Trade_No))])]), _vm._v(" "), _c('div', [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.OrderData.PayList[0].PayWayModeName !== ''),
        expression: "OrderData.PayList[0].PayWayModeName!==''"
      }],
      attrs: {
        "label": "打款方式："
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.PayList[0].PayWayModeName))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.OrderData.PayList[0].Payer !== ''),
        expression: "OrderData.PayList[0].Payer!==''"
      }],
      attrs: {
        "label": "打款人："
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.PayList[0].Payer))])])], 1)], 1)
  })), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.OrderRemark !== ''),
      expression: "OrderData.OrderRemark!==''"
    }],
    attrs: {
      "label": "下单备注："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderRemark))])]), _vm._v(" "), (_vm.OrderData.InternalRemark !== null) ? _c('el-form-item', {
    attrs: {
      "label": "内控备注："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.InternalRemark))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadOnly),
      expression: "isReadOnly"
    }],
    attrs: {
      "label": "审核状态："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadOnly),
      expression: "isReadOnly"
    }],
    attrs: {
      "label": "审核备注："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.OrderData.AuditRemark) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "label": "审核意见："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.chooseType
    },
    model: {
      value: (_vm.auditFormData.OrderStatus),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "OrderStatus", $$v)
      },
      expression: "auditFormData.OrderStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAuditRemark && !_vm.isReadOnly),
      expression: "isAuditRemark&&!isReadOnly"
    }],
    attrs: {
      "label": "审核备注："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.auditFormData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "AuditRemark", $$v)
      },
      expression: "auditFormData.AuditRemark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVoucherMoney && !_vm.isReadOnly),
      expression: "isVoucherMoney&&!isReadOnly"
    }],
    attrs: {
      "label": "打款方式："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.auditFormData.PayWayMode),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "PayWayMode", $$v)
      },
      expression: "auditFormData.PayWayMode"
    }
  }, _vm._l((_vm.PayWayModes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditFormData.PayWayMode == 1 && !_vm.isReadOnly),
      expression: "auditFormData.PayWayMode==1&&!isReadOnly"
    }],
    attrs: {
      "label": "打款人："
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.auditFormData.Payer),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "Payer", $$v)
      },
      expression: "auditFormData.Payer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVoucherMoney),
      expression: "isVoucherMoney"
    }],
    attrs: {
      "label": "凭证金额："
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.auditFormData.VoucherMoney),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "VoucherMoney", $$v)
      },
      expression: "auditFormData.VoucherMoney"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVoucherMoney),
      expression: "isVoucherMoney"
    }],
    attrs: {
      "label": "预收单："
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.auditFormData.PreReceiveCode),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "PreReceiveCode", $$v)
      },
      expression: "auditFormData.PreReceiveCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26534040!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/voucherAudit/components/voucherAuditDialog/index.vue
// module id = 1425
// module chunks = 1